import styled from "styled-components";

export const TableWrapper = styled.div`
  border-top: 2px solid black;
  overflow-x: hidden;
`;

export const TableRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #ececec;
  color: black;
  cursor: pointer;
`;

export const FAQTop = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.isActive ? "#3bb77e" : "#fff")};
  color: ${(props) => (props.isActive ? "#fff" : "black")};
  padding: 0 2rem;
  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  :hover {
    background-color: #3bb77e;
    color: white;
  }
  & i {
    font-size: 1.5rem;
  }
`;

export const FAQTitle = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  align-items: center;
`;

export const FAQContent = styled.div`
  display: ${(props) => (props.isActive ? "block" : "none")};
  border-top: 1px solid #ececec;
  padding: 2rem 2rem;
  font-weight: 300;
`;
